import React, { useContext, useEffect, useState } from "react";
import "rsuite/dist/rsuite.css";
import CustomLoader from "../../comman/Loader/CustomLoader"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import Header from "../../comman/Header-copy";
import Topbar from "../../comman/Topbar";
import List from './List';
import SearchBar from "../../comman/Search/SearchBar";
import BrandDetailModal from "./BrandDetailModal";
import CreateCampaignModal from "./CreateCampaignModal";
import { Auth } from "../../../Contexts/AuthContext";
import InvaiteModal from "./InvaiteModal";
import Footer from "../../comman/Footer";



const MyCampaigns = () => {
  const location = useLocation();
  const query = new URLSearchParams(location?.search);
  const serach = query.get('serach') ? query.get('serach') : '';
  const navigate = useNavigate();
  const [campaignData, setCampaignData] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [searchCampaign, setSearchCampaign] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [selectedCampaignId, setSelectedCampaignId] = useState('');
  const [influencer, setInfluencer] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const { setFavoriteCounts } = useContext(Auth);

  useEffect(() => {
    getBrandCampaigns()

    if (showModal || showCreate || showInviteModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    const close = (e) => {
      if (e.keyCode === 27) {
        setShowModal(false);
        setShowCreate(false);
        setShowInviteModal(false);
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)

  }, [serach,showModal, showCreate , showInviteModal]);





  const getBrandCampaigns = () => {
    let confing = {
      url: `${ApiUrl.getBrandCampaigns}?serach=${serach}`,
      method: 'GET',
      body: {}
    }

    APIRequest(
      confing,
      res => {
        setIsLoading(false);
        setCampaignData(res.campaigns);
        setSearchCampaign(res.campaigns);
      },

      err => {
        setIsLoading(false);
        alert('SERVER ERROR');
      }

    )
  }



  const searchOnChange = (value) => {

    const val = value.toLowerCase();
    const finalVal = campaignData?.filter((v) => (v?.campaign_title.toLowerCase()?.includes(val) || v?.brand.toLowerCase().includes(val)));
    setSearchCampaign(finalVal);
    setSearch(value)

  }

  const handleShowSocialPlatform = (range) => {
    let toggaleValue = false;
    if (range?.selected === undefined || range?.selected === false) {
      toggaleValue = true;
    }
    const updatedRange = { ...range, selected: toggaleValue };
    const updatedRangeArr = selectedCampaign?.allocatedBudget?.map(sb => sb?.soical_paltfom_id === updatedRange?.soical_paltfom_id ? updatedRange : sb);
    setSelectedCampaign({ ...selectedCampaign, allocatedBudget: updatedRangeArr });
  }

  const markFavorite = (id) => {
    let config = {
      url: `${ApiUrl.brandMarkFavorite}/${id}`,
      method: 'GET',
      body: {}
    }
    APIRequest(
      config,
      res => {
        setFavoriteCounts(res?.total_favorite_counts);
        localStorage.setItem('favCounts', res?.total_favorite_counts);
        const updatedSerachCampaign = searchCampaign?.map(c => c.id === id ? { ...c, is_favorite: !c.is_favorite } : c);
        const updatedCampaign = campaignData?.map(c => c.id === id ? { ...c, is_favorite: !c.is_favorite } : c);
        setSearchCampaign(updatedSerachCampaign);
        setCampaignData(updatedCampaign);
        setSelectedCampaign({ ...selectedCampaign, is_favorite: !selectedCampaign.is_favorite })
      },

      err => {

        setIsLoading(false);

      }

    )
  }

   const getInfleuncers = campaign_id => {
        let config = {
            url: `${ApiUrl.getInfluencersToInvite}/${campaign_id}`,
            method: 'GET',
            body: {}
        }
        APIRequest(
            config,
            res => {
                
                setInfluencer(res?.data);
                setSelectedCampaignId(campaign_id)
                setIsLoading(false);
                setShowInviteModal(true)
            },
            err => {
                setIsLoading(false);

            }
        )
    }




  return (
    <>
      <div className="min-h-[100vh]">
        <Header />
        <Topbar />
        <CustomLoader visible={isLoading} />
        <SearchBar  title={'My Campaigns'} search={search} searchOnChange={(val) => { searchOnChange(val) }} create="CREATE CAMPAIGN "
          add2="true"
          showCreate={showCreate} setShowCreate={setShowCreate} />



        <div className="md:grid  md:gap-6 ">
          {!isLoading && (
            <div>
              <List data={searchCampaign}
                onSelectCampaign={(item) => {
                  setSelectedCampaign(item)
                  setShowModal(true);
                }}
                setShowInviteModal={(campaign_id) => { getInfleuncers(campaign_id);  }}
                markFavorite={(id) => { markFavorite(id) }}
              />

              <BrandDetailModal
                showModal={showModal}
                setShowModal={setShowModal}
                item={selectedCampaign}
                markFavorite={(id) => { markFavorite(id) }}
                setShowSocialPlatform={(range) => handleShowSocialPlatform(range)}
                showTaskRequests={(taskRequest) => navigate('/tasks-requests/' + taskRequest?.id)}
              />

              {showCreate &&
                <CreateCampaignModal showCreate={showCreate} setShowCreate={(val) => { setShowCreate(val); getBrandCampaigns() }} />
              }

              <InvaiteModal   showModal={showInviteModal} influencer={influencer} campaign_id={selectedCampaignId} setShowModal={() => {setShowInviteModal(false);  getBrandCampaigns();}} />
            </div>
          )}
          
        </div>
      </div>

      <Footer colorClass="footerColor" clas="footer2" />

    </>
  );
};

export default MyCampaigns;
